import { useRef } from "react";
import { motion, useScroll } from "framer-motion";
import { Reveal, EASE } from "@/components/Reveal";

export default function Timeline({ steps, glow = true }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.75", "end 0.55"] });

  return (
    <div ref={ref} className="relative" data-testid="work-process-timeline">
      <div className="absolute left-[19px] md:left-1/2 top-0 bottom-0 w-px bg-white/10" />
      {glow && (
        <motion.div
          style={{ scaleY: scrollYProgress }}
          className="absolute left-[19px] md:left-1/2 top-0 bottom-0 w-px origin-top bg-gradient-to-b from-accent-bright via-accent to-accent/40 shadow-[0_0_14px_rgba(168,85,247,0.9)]"
        />
      )}
      <div className="space-y-12 md:space-y-16">
        {(steps || []).map((s, i) => (
          <div key={i} className={`relative flex items-start gap-6 pl-14 md:pl-0 md:items-center ${i % 2 === 1 ? "md:flex-row-reverse" : ""}`}>
            <div className="absolute left-0 md:left-1/2 md:-translate-x-1/2 top-0 md:top-1/2 md:-translate-y-1/2 h-10 w-10 rounded-full glass-strong node-pulse flex items-center justify-center z-10">
              <span className="font-mono-label text-[10px] text-accent-bright">{String(s.num || i + 1).padStart(2, "0")}</span>
            </div>
            <Reveal className="md:w-1/2 md:px-14" y={24}>
              <div className={i % 2 === 1 ? "md:text-right" : ""}>
                <h3 className="font-display text-lg sm:text-xl font-semibold text-white mb-2">{s.title}</h3>
                <p className="text-sm text-mist leading-relaxed">{s.body}</p>
              </div>
            </Reveal>
          </div>
        ))}
      </div>
    </div>
  );
}
